
































































































































import { POSBadge, POSContact, POSProductTypeData } from '@pos/interfaces/pos-v2';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import BpcPosContactSummary from './pos-contact-summary.vue';
import VSelect from 'vue-select';
import BpcContactTable from '@contacts/components/tables/contact-table/contact-table.vue';
import BpcPosAddBadgeModal from './pos-add-badge-modal.vue';
import BpcPosContactForm from './pos-contact-form.vue';
import { CenterSetting } from '@core/interfaces/center-setting';
import PosSeeBadgeModal from '@pos/components/v2/pos-see-badge-modal.vue';

@Component({
  name: 'bpc-pos-contact',
  components: {
    BpcPosContactSummary,
    VSelect,
    BpcContactTable,
    BpcPosAddBadgeModal,
    BpcPosContactForm,
    'bpc-pos-see-badge-modal': PosSeeBadgeModal,
  },
})
export default class PosContact extends Vue {
  // PROPS
  @Prop({ type: Object }) readonly value: POSContact;
  @Prop({ type: Number, required: true }) readonly posSessionId: number;
  @Prop({ type: Number, required: true }) readonly ticketId: number;
  @Prop({ type: Number, required: false, default: 1 }) readonly refreshContactListKey: number;
  @Prop({ type: Array }) readonly ticketProductTypes: POSProductTypeData[];
  @Prop({ type: Boolean, default: true }) readonly readOnlyTicket: boolean;

  // DATA
  searching = false;
  search = '';
  contactCollection: POSContact[] = [];
  showSearchTable: boolean = false;
  showAddBadgeModal: boolean = false;
  showSeeBadgeModal: boolean = false;
  showContactCreationForm: boolean = false;
  contactForm = null; // TODO type this : POSContact ?
  contactCreationSaveActionPortalTarget: string = 'pos-contact-creation-save-action';
  currentContactPrimaryBadge: Partial<POSBadge> = {};
  // COMPUTED
  get model(): POSContact {
    return this.value;
  }

  set model(value: POSContact) {
    this.$emit('input', value);
  }

  get disabled(): boolean {
    if (
      (this.centerSetting?.invoice_from_ticket_contact_id === this.model?.id ||
        this.ticketProductTypes?.length === 0) &&
      !this.readOnlyTicket
    ) {
      return false;
    }
    return true;
  }

  get contacCardEnabled(): boolean {
    return !!this.$store.getters['centerSettings/enableContactCard'];
  }

  get showDownloadCard(): boolean {
    return this.contacCardEnabled;
  }

  // LIFECYCLE HOOKS

  // METHODS
  onSearch(search: string) {
    this.search = search;
  }

  displayContactCreationForm() {
    this.showContactCreationForm = true;
    console.log('create contact form');
  }

  async onContactCreated(e) {
    console.log('onContactCreated', e.data);
    const contactId = e.data?.id;
    this.setContact(contactId);
    this.showContactCreationForm = false;
  }

  onSelect(event) {
    console.log('onSelect event', event);
    this.setContact(event.item.id);
    this.showSearchTable = false;
  }

  async searchContact(search: string) {
    // TODO implement this
    this.searching = true;
    this.contactCollection = await this.$posService.searchContact(this.posSessionId, search);
    this.searching = false;
  }
  async searchIfStopChanging(search: string) {
    const previousSearch = this.search;
    setTimeout(() => {
      if (previousSearch === this.search) {
        this.searchContact(search);
      }
    }, 300);
  }

  onContactUpdated(contact: POSContact) {
    this.$emit('contact-updated', contact);
  }

  seeMoreClicked() {
    this.$emit('see-more-clicked');
  }

  async seeBadgeClicked() {
    this.currentContactPrimaryBadge = await this.$posService.getPrimaryBadgeByContact(
      this.model.id,
    );
    this.showSeeBadgeModal = true;
  }

  onShowBadgeClose() {
    this.showSeeBadgeModal = false;
  }

  async setContact(contactId: number | null) {
    this.search = '';
    const ticket = await this.$posService.changeContact(
      this.posSessionId,
      this.ticketId,
      contactId,
    );
    this.$emit('ticket-updated', ticket);
  }

  isAnonymous() {
    return !this.model || this.model.type == 'anonymous';
  }

  // WATCHERS
  @Watch('search')
  onSearchChanged(search: string) {
    if (search.length < 3) {
      return;
    }
    this.searchIfStopChanging(search);
  }

  @Watch('refreshContactListKey')
  onChangeRefreshContactListKey() {
    this.contactCollection = [];
  }

  get centerSetting(): CenterSetting {
    return this.$store.getters['centerSettings/centerSettings'];
  }
}
